import styled from 'styled-components';
import { colors } from '../../theme/color';
import { ThreeDots } from 'svg-loaders-react';

export const ThreeDotsLoader = styled(ThreeDots)<{
  height?: string;
  width?: string;
  fill?: string;
  margin?: string;
}>`
  height: ${({ height }) => height || '18px'};
  width: ${({ width }) => width || '50px'};
  margin: ${({ margin }) => margin || 'auto'};
  fill: ${({ fill }) => fill || colors.white};
`;
